import { createValidator, required } from 'util/validation'

import { ChamarCidadaoPainelChamadaModel } from './model-painelChamada'

export const chamarCidadaoPainelFormValidator = createValidator<ChamarCidadaoPainelChamadaModel>({
  tipoAtendimento: [required],
  sala: [required],
})
